import type { ColorScheme } from './colors';

function readCssVar(name: string): string | undefined {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || undefined;
}

/** AG Grid и legacy CSS — значения из активной shadcn-темы. */
export function syncTelegramThemeCssVars() {
  const root = document.documentElement;

  const set = (tgName: string, cssVar: string, fallbackVar?: string) => {
    const value = readCssVar(cssVar) ?? (fallbackVar ? readCssVar(fallbackVar) : undefined);
    if (value) {
      root.style.setProperty(tgName, value);
    }
  };

  set('--tg-theme-bg-color', '--background');
  set('--tg-theme-text-color', '--foreground');
  set('--tg-theme-hint-color', '--muted-foreground');
  set('--tg-theme-secondary-bg-color', '--muted', '--background');
  set('--tg-theme-button-color', '--primary');
  set('--tg-theme-button-text-color', '--primary-foreground');
  set('--tg-theme-link-color', '--primary');
}

export function applyDocumentThemeClass(_colorScheme: ColorScheme) {
  // Тема задаётся классами light/dark на <html> через ThemeProvider.
}
